<div class="cabecalho-rota-container">
  <!-- Campos na ordem configurada -->
  <ng-container *ngFor="let campo of camposGrid">

    <div class="info-container" *ngIf="campo === 'placa' && dados.placa">
      <div class="small-font">{{ 'HEADER_GADGET.PROPERTIES.VEHICLE' | translate }}</div>
      <ngx-skeleton-loader *ngIf="loaded && !((loaded | async) ?? 0) else Placa"></ngx-skeleton-loader>
      <ng-template #Placa>
        <app-placa [placa]="dados.placa" *ngIf="!loaded || (loaded | async)"></app-placa>
      </ng-template>
    </div>

    <div class="info-container" *ngIf="campo === 'nomeRota' && dados.nome">
      <div class="small-font">{{ 'HEADER_GADGET.PROPERTIES.NAME' | translate }}</div>
      <ngx-skeleton-loader *ngIf="loaded && !((loaded | async) ?? 0) else Nome"></ngx-skeleton-loader>
      <ng-template #Nome>
        <div class="identification" [matTooltip]="dados.nome || ''">{{dados.nome || ''}}</div>
      </ng-template>
    </div>

    <div class="info-container" *ngIf="campo === 'identificador'">
      <div class="small-font">{{ 'HEADER_GADGET.PROPERTIES.ID' | translate }}</div>
      <ngx-skeleton-loader *ngIf="loaded && !((loaded | async) ?? 0) else ID"></ngx-skeleton-loader>
      <ng-template #ID>
        <div class="identification" [matTooltip]="dados.identificador || ''">
          {{dados.identificador || ''}}
        </div>
      </ng-template>
    </div>

    <div class="info-container" *ngIf="campo === 'nomeMotorista' && dados.motorista">
      <div class="small-font">{{ 'HEADER_GADGET.PROPERTIES.DRIVER' | translate }}</div>
      <div class="motorista ellipsis-1" [matTooltip]="dados.motorista || ''">{{dados.motorista || ''}}</div>
    </div>

    <div class="info-container" *ngIf="campo === 'codigoVeiculo' && dados.codigoVeiculo">
      <div class="small-font">{{ 'HEADER_GADGET.PROPERTIES.VEHICLE_CODE' | translate }}</div>
      <div class="identification" [matTooltip]="dados.codigoVeiculo || ''">{{dados.codigoVeiculo || ''}}</div>
    </div>

    <div class="info-container" *ngIf="campo === 'codigoCarroceria' && dados.codigoCarroceria">
      <div class="small-font">{{ 'HEADER_GADGET.PROPERTIES.BODYWORK_CODE' | translate }}</div>
      <div class="identification" [matTooltip]="dados.codigoCarroceria || ''">{{dados.codigoCarroceria || ''}}</div>
    </div>

    <div class="info-container" *ngIf="campo === 'placaCarroceria' && dados.placaCarroceria">
      <div class="small-font">{{ 'HEADER_GADGET.PROPERTIES.BODYWORK' | translate }}</div>
      <app-placa [placa]="dados.placaCarroceria"></app-placa>
    </div>

  </ng-container>

  <div class="info-container" *ngIf="rastreamento">
    <div class="small-font">{{ 'HEADER_GADGET.PROPERTIES.TRACKING' | translate }}</div>
    <ngx-skeleton-loader *ngIf="loaded && !((loaded | async) ?? 0) else Nome"></ngx-skeleton-loader>
    <ng-template #Nome>
      <div class="identification" [matTooltip]="rastreamento || ''">{{rastreamento|| ''}}</div>
    </ng-template>
  </div>
</div>
